const getAria = (placeholder: string, label?: string): string =>
  [placeholder, label].filter(Boolean).join(', ');

export default getAria;
